UC.views.ProposalsIntro = Backbone.View.extend({
  initialize: function() {
    new UC.views.JobsProposals({ el: this.$el });
  },
});
